module.exports = __webpack_public_path__ + "static/media/scream05.0f1142f3.wav";